import { NavLink } from 'react-router';

import { Icon, type IconName } from '../components/icons';
import { useOrderPricePartner } from '../pricing/usePartner';
import { useProject } from '../projects/context';
import { navItems } from './navigation';

const icons: Record<string, IconName> = { '.': 'home', akquise: 'phone', tickets: 'message', termine: 'calendar', leads: 'user', vertrieb: 'award', preisliste: 'note' };

// BottomNav: Navigation unten für den Außendienst auf dem Handy – große Ziele, mit dem Daumen erreichbar.
export function BottomNav() {
  const { can } = useProject();
  const orderPrice = useOrderPricePartner();
  const items = navItems.filter((item) => item.visible({ can, fieldOnly: true, orderPrice }));
  return (
    <nav className="bottom-nav" aria-label="Schnellnavigation">
      {items.map((item) => (
        <NavLink key={item.to} to={item.to} end={item.end} className="bottom-nav-link">
          <Icon name={icons[item.to] ?? 'dot'} size={22} />
          <span>{item.label}</span>
        </NavLink>
      ))}
      <NavLink to="profil" className="bottom-nav-link">
        <Icon name="user" size={22} />
        <span>Profil</span>
      </NavLink>
    </nav>
  );
}
